import gql from 'graphql-tag'

export const SIGNUP = gql`
    mutation CreateAccount($data: CreateAccountInput!) {
        createAccount(data: $data) {
            accessToken
            refreshToken
        }
    }
`
export const REFRESH_TOKEN = gql`
    mutation refreshToken($data: RefreshTokenInput!) {
        refreshToken(data: $data) {
            accessToken
        }
    }
`

export const LOGIN = gql`
    mutation logIn($data: LogInInput!) {
        logIn(data: $data) {
            accessToken
            refreshToken
        }
    }
`

export const VERIFY = gql`
    mutation verifyAccount($data: VerifyInput!) {
        verify(data: $data) {
            accessToken
            refreshToken
        }
    }
`
export const FORGOT = gql`
    mutation forgotPassword($data: ForgotPasswordInput!) {
        forgotPassword(data: $data)
    }
`

export const ADD_CARD_SOURCE = gql`
    mutation addCardSource($data: AddCardSourceInput!) {
        addCardSource(data: $data)
    }
`

export const SELECT_PLAN = gql`
    mutation selectPlan($data: SelectPlanInput!) {
        selectPlan(data: $data)
    }
`

export const ME = gql`
    query me {
        me {
            id
            email
            firstName
            lastName
            isVerified
            account {
                id
                stripeCustomerId
                trialEnd
                paymentSources
                plan {
                    name
                    interval
                    amount
                    renews
                }
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/operations/User/index.js